import { StrapiFuzzySearch } from "@/src/type/strapi";
import { get } from "./StrapiService";

async function query(query: string, locale?: string, populate?: string) {
  const response = await get<StrapiFuzzySearch>(
    undefined,
    undefined,
    undefined,
    `fuzzy-search/search?query=${encodeURIComponent(query)}&locale=${locale ?? "en"}${populate ?? ""}`
  );
  return response;
}

export default {
  query,
};
